/* =========================
   CART COUNT
========================= */
function updateCartCount() {
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      const count = cart.item_count;

      document.querySelectorAll('.cart-count').forEach(el => {
        el.textContent = count;
      });

      document.querySelectorAll('.cart-count-badge').forEach(el => {
        el.textContent = count;
      });
    });
}


/* =========================
   INIT ON LOAD
========================= */
document.addEventListener('DOMContentLoaded', () => {

  /* 🔥 CART OBSERVER */
  const cartDrawer = document.querySelector('cart-drawer');

  if (cartDrawer) {
    const observer = new MutationObserver(() => {
      updateCartCount();
    });

    observer.observe(cartDrawer, {
      childList: true,
      subtree: true
    });
  }

  /* 🔥 SCROLL HEADER */
  const header = document.getElementById('site-header');

  if (header) {
    let lastScroll = 0;
    let ticking = false;

    function onScroll() {
      const current = window.scrollY;

      // top
      if (current <= 0) {
        header.classList.remove('is-visible', 'is-hidden');
        lastScroll = current;
        return;
      }

      // down
      if (current > lastScroll) {
        header.classList.remove('is-visible');
        header.classList.add('is-hidden');
      } 
      // up
      else {
        header.classList.remove('is-hidden');
        header.classList.add('is-visible');
      }

      lastScroll = current;
    }

    window.addEventListener('scroll', () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          onScroll();
          ticking = false;
        });
        ticking = true;
      }
    });
  }

  /* 🔥 VIDEO INIT */
  initVideos();

});


/* =========================
   VIDEO MODULE
========================= */
function initVideos() {
  const videos = document.querySelectorAll(".js-video");

  videos.forEach(video => {
    if (video.dataset.initialized) return;
    video.dataset.initialized = "true";

    const container = video.closest(".video-module");
    if (!container) return;

    const playBtn = container.querySelector(".js-video-play");
    const muteBtn = container.querySelector(".js-video-mute");

    const autoplay = video.dataset.autoplay === "true";
    const muted = video.dataset.muted === "true";

    function syncUI() {
      if (playBtn) {
        video.paused
          ? playBtn.classList.add("is-paused")
          : playBtn.classList.remove("is-paused");
      }

      if (muteBtn) {
        video.muted
          ? muteBtn.classList.remove("is-unmuted")
          : muteBtn.classList.add("is-unmuted");
      }
    }

    // initial state
    if (playBtn) {
      autoplay
        ? playBtn.classList.remove("is-paused")
        : playBtn.classList.add("is-paused");
    }

    if (muteBtn) {
      muted
        ? muteBtn.classList.remove("is-unmuted")
        : muteBtn.classList.add("is-unmuted");
    }

    video.addEventListener("play", syncUI);
    video.addEventListener("pause", syncUI);
    video.addEventListener("volumechange", syncUI);

    playBtn?.addEventListener("click", () => {
      video.paused ? video.play() : video.pause();
    });

    muteBtn?.addEventListener("click", () => {
      video.muted = !video.muted;
    });
  });
}


/* =========================
   SHOPIFY EDITOR SUPPORT
========================= */
document.addEventListener("shopify:section:load", initVideos);
